import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import {
  NgxExtendedPdfViewerModule,
  NgxExtendedPdfViewerService,
  pdfDefaultOptions
} from 'ngx-extended-pdf-viewer';
import { emulateClick } from '../../core/a11y';
import { HoverGradientDirective } from '../../shared/directives/hover-gradient.directive';

@Component({
  selector: 'app-hr-policies',
  providers: [ NgxExtendedPdfViewerService ],
  styles: ":host ::ng-deep .page { margin: 0 auto !important; }",
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    HoverGradientDirective,
    NgxExtendedPdfViewerModule
  ],
  templateUrl: './hr-policies.component.html'
})
export class HrPoliciesComponent {
  steps = [ 1, 2, 3, 4 ];
  page: number = 1;
  protected readonly Math = Math;
  protected readonly emulateClick = emulateClick;

  constructor() {
    pdfDefaultOptions.doubleTapZoomsInHandMode = false;
  }
}
